<div class="w-full lg:max-w-full lg:flex login-page">
  <div
    class="border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-login"
  >
    <div class="flex justify-between mb-10">
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_unchk.png')"
      ></div>
      <div
        class="logo-icon"
        style="
          background-image: url('assets/img/logo_master_card.png');"
      ></div>
    </div>

    <div class="">
      <app-card-form>
        <img src="assets/icons/check-circle.png" alt="Mon Image" style="width: 60px; height: 60px; margin: auto;">
        <div class="">
          <div class="inline-flex items-center justify-center w-full">
            <hr class="w-full h-px bg-gray-300 border-0 dark:bg-gray-700" />
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form>
            <div style="height: 116px; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 15px;">
              <div style="text-align: center; color: #101828; font-size: 24px; font-family: Inter; font-weight: 600; line-height: 32px; word-wrap: break-word">Email vérifié !</div>
              <div style="text-align: center; color: #475467; font-size: 16px; font-family: Inter; font-weight: 400; line-height: 24px; word-wrap: break-word">Votre e-mail a été vérifié avec succès. Cliquez sur le lien ci-dessous pour vous connecter à votre compte.</div>
            </div>

            <button style="width: 360px; padding: 10px 18px; background: #1D71B8; box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05); border-radius: 8px; overflow: hidden; border: 1px #1D71B8 solid; display: flex; margin: auto; justify-content: center; align-items: center; gap: 8px;">
              <div style="color: white; font-size: 16px; font-family: Inter; font-weight: 600; line-height: 24px; word-wrap: break-word" routerLink="/fode-connexion">Se connecter</div>
            </button>
          </form>
          <br> <br>
          <div class="mt-5">

          </div>
        </div>
      </app-card-form>
    </div>

    <div class="flex justify-center mt-8">
      <div
        class="logo-icon"
        style="background-image: url('assets/img/logo_force_n.png')"
      ></div>
    </div>
  </div>
</div>
